import qs from 'query-string';

import appSettings from 'wanderu-config';
import { selectLocale } from 'wanderu-i18n';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import { TixService } from 'wanderu-service-wapi';

import { POLL_STATUS_DELAY_MS } from '../../../constants';
import {
    actions as bookingActions,
    selectors as bookingSelectors,
} from '../../appstate';
import { mapPollingStatus } from '../../appstate/utils';
import { pollEndpoint } from '../utils';
import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-app-booking:pollInsuranceStatus');

function pollInsuranceStatus(insuranceOrderId) {
    return async (dispatch, getState) => {
        dispatch(actions.startWork(insuranceOrderId));

        let error;
        let meta;
        try {
            const locale = selectLocale(getState());
            const {
                itineraryId,
                bookingSessionId,
            } = bookingSelectors.selectBookingInfo(getState());

            const queries = {
                booking_session_id: bookingSessionId,
                itinerary_id: itineraryId,
                locale,
                order_id: insuranceOrderId,
            };

            const fetchFn = async () => {
                const { result } = await TixService.get(`v4/book/status?${qs.stringify(queries)}`);
                const status = mapPollingStatus(result);

                await dispatch(bookingActions.setInsuranceStatus(result));

                if (!status.isQueued && !status.isProcessing) {
                    const property = {
                        booking_session_id: bookingSessionId,
                        insurance_order_id: insuranceOrderId,
                        itinerary_id: itineraryId,
                        status: result,
                    };
                    SnowplowService.fireStructuredEvent({
                        action: 'insurance_purchase',
                        category: 'checkout',
                        property: JSON.stringify(property),
                    });
                }
            };

            const shouldContinue = () => {
                const status = bookingSelectors.selectInsuranceStatus(getState());
                return status.isQueued || status.isProcessing;
            };

            await pollEndpoint(fetchFn, shouldContinue, POLL_STATUS_DELAY_MS);
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            error = ex?.responseBody?.error;

            logger.error('pollInsuranceStatus', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });
            throw ex;
        } finally {
            dispatch(actions.endWork(insuranceOrderId, meta, error));
        }
    };
}

const pollInsuranceStatusAction = {
    poll: pollInsuranceStatus,
    ...selectors,
    ...actions,
};

export {
    pollInsuranceStatusAction,
};

export default {
    [namespace]: reducer,
};
